import { IDataComparable } from '../../../contracts/data-comparable.js';
import { isNotNullOrUndefined } from '../../../utility/null-safety.js';
import { SerializedData } from '../../dto/dto.js';
import { Vec2 } from '../../math/vec2.js';

export abstract class SeatingElement implements IDataComparable {
  private _parent: WeakRef<SeatingElement> | null;

  constructor(
    public readonly uniqueId: number,
    public readonly enabled: boolean,
    public readonly position: Vec2,
    public readonly rotation: number,

    /**
     * Weak references to layout tree node that this seat belongs to.
     */
    parent: WeakRef<SeatingElement> | null = null,
  ) {
    this._parent = parent;
  }

  get parent(): WeakRef<SeatingElement> | null {
    return this._parent;
  }

  // Type ID of the seating element represented by a single byte [1, 256).
  abstract get $typeId(): number;

  abstract toJson(): SerializedData;
  abstract isSame(other: this): boolean;
  abstract clone(parent: WeakRef<SeatingElement> | null): this;

  setParent(parent: SeatingElement | null): void {
    this._parent = isNotNullOrUndefined(parent) ? new WeakRef(parent) : null;
  }
}
